import React, { createContext, useState, useEffect } from "react";
import contentFile from "../../constants/contentFile.json";
import { validateEmail, createCookie } from "../../utils/service";
import { useNavigate } from "react-router";
import routeContstants from "../../constants/routeConstants.json";
import { loginApi, loginMfa } from "../../api/Api";

export const LoginContext = createContext({});

export const LoginContextProvider = ({ children }) => {
  const pageContent = contentFile.authPage;
  const navigate = useNavigate();
  const [permissionUpdatePopup, setPermissionUpdatePopup] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userId, setUserId] = useState("");

  const [mfaPop, setMfaPop] = useState("");
  const [mfaType, setMfaType] = useState("");
  const [errorPopupTrigger, setErrorPopupTrigger] = useState(null);

  // Validation Error message state
  const [emailValidationMsg, setEmailValidationMsg] = useState("");
  const [passwordValidateMsg, setPasswordValidateMsg] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [errorAlertShow, setErrorAlertShow] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [statusCode, setStatusCode] = useState(0);
  const [enteredCode, setEnteredCode] = useState(["", "", "", "", "", ""]);

  const [buttonText, setButtonText] = useState("");

  // Password Show and Hide
  const [passwordType, setPasswordType] = useState("password");
  const toggleEyeIcon = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  // set input value to state using handle change

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    passwordValidation(e.target.value);
  };

  // Email validation

  const emailValidation = (value) => {
    if (value === "") {
      setEmailValidationMsg(pageContent.emailRequired);
      return false;
    } else if (!validateEmail(value)) {
      setEmailValidationMsg(pageContent.invalidEmail);
      return false;
    } else {
      setEmailValidationMsg("");
      return true;
    }
  };

  // Password validation
  const passwordValidation = (value) => {
    if (value === "") {
      setPasswordValidateMsg(pageContent.passwordRequired);
      return false;
    } else {
      setPasswordValidateMsg("");
      return true;
    }
  };

  const onClickReSend = () => {
    const userData = {
      email: email,
      password: password,
    };
    loginApi(userData);
  };

  const submitPopupData = async () => {
    try {
      // setMfaPop(false);
      const otpCode = enteredCode.join("");
      const mfaLogin = await loginMfa(userId, otpCode, mfaType);

      if (mfaLogin.status === 200) {
        const accessToken = mfaLogin?.data?.data?.token;
        createCookie("x-access-token", accessToken);
        navigate(routeContstants.ROLE_LIST);
        const rolePermissions = mfaLogin?.data?.data?.user?.role?.permissions;
        localStorage.setItem("permissions", JSON.stringify(rolePermissions));
        localStorage.setItem("roleId", mfaLogin?.data?.data?.user?.role?._id);
        localStorage.setItem("adminId", mfaLogin?.data?.data?.user?._id);
        const roleIdentifier = mfaLogin?.data?.data?.user?.role?.identifier;
        localStorage.setItem("roleIdentifier", JSON.stringify(roleIdentifier));
      } else {
        setErrorAlertMessage("MFA login failed. Please try again.");
        setEnteredCode(["", "", "", "", "", ""]);
        setErrorAlertShow(true);
      }
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || "Something went wrong...";

      setErrorAlertMessage(errorMessage);
      setStatusCode(responseStatus);
      // setEnteredCode(["", "", "", "", "", ""]);
      setErrorAlertShow(true);
      setErrorPopupTrigger("submitPopupData");

      if (responseStatus === 400) {
        setButtonText("Try Again");
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText("Login");
      } else {
        setButtonText("Try Again");
      }
    }
  };

  const submitLogin = async (e) => {
    e.preventDefault();
    const userData = {
      email: email,
      password: password,
    };
    if (emailValidation(email) && passwordValidation(password)) {
      setSpinnerStatus(true);
      try {
        const getData = await loginApi(userData);
        // setAdminId(getData?.data?.data?.user?._id)
        localStorage.setItem("roleId", getData?.data?.data?.user?.role?._id);
        localStorage.setItem("adminId", getData?.data?.data?.user?._id);
        if (getData.data.data.mfaEnabled === true) {
          setSpinnerStatus(false);

          setUserId(getData.data.data.user._id);
          setMfaType(getData.data.data.type);
          // loginMfa(userId, code, authToken, authType)
          setMfaPop(true);
        } else {
          if (getData?.data?.statusCode === 200) {
            const accessToken = getData?.data?.data?.token;
            // storing Permissions and RoleIdentifier To Session
            const rolePermissions =
              getData?.data?.data?.user?.role?.permissions;
            localStorage.setItem(
              "permissions",
              JSON.stringify(rolePermissions)
            );
            const roleIdentifier = getData?.data?.data?.user?.role?.identifier;
            createCookie("x-access-token", accessToken);
            navigate(routeContstants.DASHBOARD);
            localStorage.setItem(
              "roleIdentifier",
              JSON.stringify(roleIdentifier)
            );
            setSpinnerStatus(false);
          }
        }
      } catch (error) {
        const responseStatus = error?.response?.data?.statusCode;
        const errorMessage =
          error?.response?.data?.message || "Something went wrong...";

        setErrorAlertMessage(errorMessage);
        setStatusCode(responseStatus);
        setErrorAlertShow(true);
        setErrorPopupTrigger("submitLogin");

        if (responseStatus === 400) {
          setButtonText("Try Again");
        } else if (responseStatus === 401 || responseStatus === 403) {
          setButtonText("Login");
        } else {
          setButtonText("Try Again");
        }
        setSpinnerStatus(false);
      }
    }
  };

  // Page navigation forgot password

  const navigatePage = () => {
    navigate(routeContstants.FORGOT_PASSWORD);
  };

  const providerValue = {
    passwordType,
    toggleEyeIcon,
    pageContent,
    submitLogin,
    emailValidationMsg,
    email,
    password,
    handleEmailChange,
    spinnerStatus,
    handlePasswordChange,
    passwordValidateMsg,
    navigatePage,
    errorAlertMessage,
    errorAlertShow,
    setErrorAlertMessage,
    setErrorAlertShow,
    statusCode,
    mfaPop,
    emailValidation,
    setMfaPop,
    enteredCode,
    setEnteredCode,
    mfaType,
    userId,
    submitPopupData,
    onClickReSend,
    emailValidation,
    buttonText,
    errorPopupTrigger,
    permissionUpdatePopup,
  };
  return (
    <LoginContext.Provider value={providerValue}>
      {children}
    </LoginContext.Provider>
  );
};
